import { useState } from 'react'
import { Button } from '@components/primitives/Button.js'
import { Modal } from '@components/primitives/Modal.js'

type Props = {
  open: boolean
  nome: string
  onConfirm: () => Promise<void>
  onClose: () => void
}

export function ConfirmDeleteModal({ open, nome, onConfirm, onClose }: Props) {
  const [step, setStep] = useState(1)
  const [busy, setBusy] = useState(false)

  const handle = async () => {
    if (step === 1) {
      setStep(2)
      return
    }
    setBusy(true)
    await onConfirm()
    setBusy(false)
    setStep(1)
  }

  const close = () => {
    setStep(1)
    onClose()
  }

  return (
    <Modal
      open={open}
      title='Excluir referência'
      size='sm'
      onClose={close}
      actions={
        <div className='cf3-modal-actions'>
          <Button variant='ghost' onClick={close} disabled={busy}>
            Cancelar
          </Button>
          <Button variant='danger' onClick={handle} loading={busy}>
            {step === 1 ? 'Excluir' : 'Confirmar exclusão'}
          </Button>
        </div>
      }
    >
      <p className='cf-confirm-msg'>
        {step === 1 ? (
          <>
            Remover referência a <strong>"{nome}"</strong>? O arquivo físico não é apagado.
          </>
        ) : (
          <>
            Confirma a remoção definitiva de <strong>"{nome}"</strong>?
          </>
        )}
      </p>
    </Modal>
  )
}
